import { KursInfoVO } from "@core/api/v1";
import TypEnum = KursInfoVO.TypEnum;

export class KursFarben {
    public static kursFarbeMap: { [key in TypEnum]: string } = {
        ZERT_PENSION: 'red',
        REZERT_PENSION: 'violet',
        REZERT_PENSION_PSYCHIATRIE: 'purple',
        ZERT_PFLEGEGELD: 'bold-blue',
        ZERT_PFLEGEGELD_KINDER: 'yellow',
        REZERT_PFLEGEGELD: 'green',
        ZERT_GUTACHTUNG_AUVA: 'dark-red',
    };

    public static holeClass(typ: TypEnum): string {
        return this.kursFarbeMap[typ];
    }
}
